/**
 * 이 기기가 이 사이트에 제공한 저장 공간의 사용량.
 *
 * Owns:
 * - `navigator.storage.estimate()` 경계.
 * - 값을 얻지 못하는 세 경우(미지원·거절·값 없음)를 하나의 "알 수 없음" 으로 모으는 규칙.
 *
 * Does not own:
 * - 표시 문구·단위 변환(`formatBytes`).
 * - 무엇을 지울지(`app/hatcheryDatabase`).
 *
 * 값은 **origin 전체**의 사용량이다. IndexedDB 와 localStorage·Cache 를 모두 합친 수다.
 * 브라우저가 의도적으로 정밀도를 낮춘 근삿값이다. 캐시를 비워도 0 이 되지 않는다.
 */

export type StorageUsage =
  | { status: "loading" }
  | { status: "ready"; bytes: number }
  // 미지원 브라우저이거나 브라우저가 값을 제공하지 않았다. 사용량 줄만 숨기고 비우기는 그대로 둔다.
  | { status: "unknown" };

export async function readStorageUsage(): Promise<StorageUsage> {
  const storage = typeof navigator === "undefined" ? undefined : navigator.storage;
  if (typeof storage?.estimate !== "function") {
    return { status: "unknown" };
  }
  try {
    const { usage } = await storage.estimate();
    return typeof usage === "number" && Number.isFinite(usage)
      ? { status: "ready", bytes: usage }
      : { status: "unknown" };
  } catch {
    // 사생활 보호 모드·정책 차단이면 여기서 예외가 난다. 사용량을 모르는 것은 설정 화면의 실패가 아니다.
    return { status: "unknown" };
  }
}
